<template>
    <div class="comics page">
        <wrapper
            column
            :backgroundImage="require('@/assets/main-bg.jpg')"
            scrollable
        >
            <BackBtn />
            <div class="float image-container">
                <img
                    src="@/assets/Stage/Comics/common/top.webp"
                    alt=""
                    width="100%"
                />
                <div class="text">
                    <div class="header">漫畫</div>
                </div>
            </div>
            <div class="main">
                <img
                    class="picture"
                    v-for="(image, i) in images"
                    :key="i"
                    :src="image"
                />
                <button @click="start">開始答題</button>
                <div class="float-footer image-container">
                    <img
                        src="@/assets/Stage/Comics/common/footer.webp"
                        alt=""
                        width="100%"
                    />
                </div>
            </div>
        </wrapper>
    </div>
</template>

<script>
import _ from 'lodash';
import PageGeneral from '@/mixins/PageGeneral';
import BackBtn from '@/components/Button/BackButton.vue';

export default {
    mixins: [PageGeneral],
    components: { BackBtn },
    computed: {
        level() {
            return this.$route.params.level;
        },
        images() {
            const count = _.get({ 1: 2 }, this.level, 4);
            return _.range(1, count + 1).map((i) => {
                const url = `assets/Stage/Comics/comics/${this.level}/${this.level}-${i}.webp`;
                // eslint-disable-next-line import/no-dynamic-require, global-require
                return require(`@/${url}`);
            });
        },
    },
    methods: {
        start() {
            this.$router.replace({ name: 'Stage_Comic_Question', params: { level: this.level } });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/main.scss";
.comics {
    .image-container.float {
        position: relative;
        .text {
            color: #fff;
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .header {
                font-size: 2em;
                font-weight: bold;
            }
        }
    }
    .main {
        margin-top: max(-12vw, -50px);
        padding: 0 20px 20px 20px;
        .picture {
            width: 100%;
            border-radius: 16px;
        }
        .float-footer {
            z-index: -1;
        }
        button {
            margin-top: 20px;
            width: 300px;
            border-radius: 36px;
            background-color: #6b83bc;
            font-size: 1.8em;
            font-weight: bold;
            color: white;
            padding: 15px;
        }
    }
}
</style>
